export type QuarterKey = "Q1" | "Q2" | "Q3" | "Q4";

export type QuarterTotals = Record<QuarterKey, number>;

export type QuarterOption = {
  key: QuarterKey;
  label: string;
  period: string;
};

export const quarterOptions: QuarterOption[] = [
  { key: "Q1", label: "Q1", period: "Jan - Mar" },
  { key: "Q2", label: "Q2", period: "Avr - Juin" },
  { key: "Q3", label: "Q3", period: "Juil - Sep" },
  { key: "Q4", label: "Q4", period: "Oct - Dec" },
];
